module.exports = vendor_6b8eaca5301ac9ae9cf1;